import type { MouseEvent } from 'react';

import { colors } from './fj-styles';

// function to determine if prop is a hex
const isHex = (color?: string): boolean => /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color as string);

// utility function for mapping color strings to hex codes
export const getHexFromProps = (color?: string): string | null => {
  if (isHex(color)) {
    return color as string;
  }

  switch (color) {
    case 'red':
      return colors.red.hex();
    case 'white':
      return colors.white.hex();
    case 'teal':
      return colors.teal.hex();
    case 'black':
      return colors.black.hex();
    case 'deep-red':
      return colors.deepRed.hex();
    case 'transparent':
      return 'transparent';
    default:
      return null;
  }
};

// utility function for evaluating numbers or strings as valid props
export const evaluateProp = (prop: number | string): string => {
  if (typeof prop === 'number') {
    return `${prop}px`;
  }

  return prop;
};

// utility function for adding alpha to hex colors
export const hexToRGBA = (color: string, alpha?: number | string): string => {
  if (!isHex(color)) return color;

  const r = parseInt(color.slice(1, 3), 16);
  const g = parseInt(color.slice(3, 5), 16);
  const b = parseInt(color.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  return `rgb(${r}, ${g}, ${b})`;
};

export const swallowClick =
  (callback: () => void) =>
    (ev: MouseEvent): void => {
      ev.preventDefault();
      ev.stopPropagation();
      callback();
    };

export const isWindows = (): boolean => /^Win/.test(window.navigator.platform);

export const gridUnits = (units: number): string => `${units * 20}px`;

export const escapeRegExp = (string: string): string => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
